import React from 'react';

function TermsOfService() {
  return (
    <div className="w-full p-6">
      <h1 className="text-2xl font-bold mb-4">Terms of Service</h1>
      <p className="mb-4 text-sm text-gray-700 dark:text-gray-300">Last updated: November 30, 2025</p>

      <section className="mb-4">
        <h2 className="font-semibold">1. Acceptance of Terms</h2>
        <p className="text-sm text-gray-700 dark:text-gray-300">By accessing or using this site and its services (the "Service"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, do not use the Service.</p>
      </section>

      <section className="mb-4">
        <h2 className="font-semibold">2. Eligibility</h2>
        <p className="text-sm text-gray-700 dark:text-gray-300">You must be at least the minimum age required in your jurisdiction to use the Service. If you use the Service on behalf of an organization, you represent that you have the authority to bind that organization to these Terms.</p>
      </section>

      <section className="mb-4">
        <h2 className="font-semibold">3. Use of the Service</h2>
        <p className="text-sm text-gray-700 dark:text-gray-300">You agree to use the Service only for lawful purposes and in a way that does not infringe the rights of others. You must not attempt to interfere with the operation of the Service or access data you are not authorized to view.</p>
      </section>

      <section className="mb-4">
        <h2 className="font-semibold">4. User Content</h2>
        <p className="text-sm text-gray-700 dark:text-gray-300">When you submit content (usernames, chat messages, custom images, etc.) you grant the Service a worldwide, non-exclusive, royalty-free license to use, reproduce, and display that content to provide the Service. You are responsible for the content you submit and must ensure you have any rights necessary to submit it.</p>
      </section>

      <section className="mb-4">
        <h2 className="font-semibold">5. Intellectual Property</h2>
        <p className="text-sm text-gray-700 dark:text-gray-300">All rights, title and interest in and to the Service, including source code, designs, trademarks and logos, are owned by the Service owner or its licensors. These Terms do not grant you any rights to use the Service owner's trademarks or other branding.</p>
      </section>

      <section className="mb-4">
        <h2 className="font-semibold">6. Disclaimers</h2>
        <p className="text-sm text-gray-700 dark:text-gray-300">The Service is provided "as is" and "as available". To the fullest extent permitted by law, the Service disclaims all warranties, express or implied, including merchantability and fitness for a particular purpose.</p>
      </section>

      <section className="mb-4">
        <h2 className="font-semibold">7. Limitation of Liability</h2>
        <p className="text-sm text-gray-700 dark:text-gray-300">To the extent permitted by applicable law, the Service and its owners will not be liable for any indirect, incidental, special or consequential damages arising out of your use of the Service.</p>
      </section>

      <section className="mb-4">
        <h2 className="font-semibold">8. Termination</h2>
        <p className="text-sm text-gray-700 dark:text-gray-300">We may suspend or terminate your access to the Service at any time for violations of these Terms or for other business reasons. On termination, your right to use the Service ends immediately.</p>
      </section>

      <section className="mb-4">
        <h2 className="font-semibold">9. Changes to Terms</h2>
        <p className="text-sm text-gray-700 dark:text-gray-300">We may update these Terms from time to time. If we make material changes, we will try to provide notice by posting a prominent announcement in the Service. Continued use after updates constitutes acceptance of the revised Terms.</p>
      </section>

      <section className="mb-4">
        <h2 className="font-semibold">10. Governing Law</h2>
        <p className="text-sm text-gray-700 dark:text-gray-300">These Terms are governed by the laws of the jurisdiction where the Service owner is located, without regard to conflict of laws rules.</p>
      </section>

      <section className="mb-6">
        <h2 className="font-semibold">11. Contact</h2>
        <p className="text-sm text-gray-700 dark:text-gray-300">If you have questions about these Terms, contact us via the project's repository or the contact information provided in the app.</p>
      </section>

      <div className="text-sm text-gray-600">&copy; {new Date().getFullYear()} Game for a Laugh. All rights reserved.</div>
    </div>
  );
}

export default TermsOfService;
